import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-broadcastings-tv-format',
  templateUrl: './broadcastings-tv-format.component.html',
  styleUrls: ['./broadcastings-tv-format.component.scss']
})
export class BroadcastingsTvFormatComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
